import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Theme, createStyles, WithStyles, RadioGroup, FormControlLabel, Radio, Typography, withStyles, Avatar, Card, CardContent, Button } from '@material-ui/core';
import { UserBody } from '../types/UsersBody';
import { MyPATDialog, MyPATIconButton } from '../../common';
import { CloseOutlined as CloseIcon, CollectionsOutlined, } from '@material-ui/icons';
import { removeUserRole } from '../actions/usersActions';
import { usersList } from '../actions/usersActions';

const styles = (theme: Theme) => createStyles({
    '.MuiTypography-alignCenter-137':{
        'text-align':'left !important',
    },
    userName: {
        color: theme.palette.grey[500],
        position: "absolute",
        padding: theme.spacing.unit / 2
    },
    userNameEmail:{
        color: "#333333ad",
        position: "absolute",
        padding: "4px 4px 4px 20px",
        fontSize:"20px", 
    },
    profileAvatar: {
        height: theme.spacing.unit * 5,
        width: theme.spacing.unit * 5,
        display: "inline-flex"
    },
    dialogCloseContainer: {
        textAlign: 'right',
    },
    selectRoleRadioRoot: {
        padding: theme.spacing.unit / 2,
    },
    selectRoleRoot: {
        marginLeft: `-${theme.spacing.unit / 2}px`,
        marginRight: theme.spacing.unit * 3,
    },
    selectRoleRadioLabel: {
        textTransform: 'capitalize',
    },
    removeRole: {
        position: "absolute",
        right: "50px",
    },
    removeRoleBtn: {
        float: "right",
    },
    miniLiText: {
        paddingLeft: theme.spacing.unit * 3
    },
    selectRole:{
        'font-size':"16px",
        'font-weight':"500",
    },
    rolesList: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
        '& > li': {
            marginBottom: theme.spacing.unit,
            '&.radioLabel': {
                '& > span': {
                    padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
                },
                '& > .libraryName': {
                    marginLeft: theme.spacing.unit * 4.5,
                }
            },
            '&.controlLabel': {
                '& > label': {
                    marginLeft: 0,
                    '& > span:first-child': {
                        padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
                    },
                    '& > span:last-child': {
                        ...theme.typography.body1,
                    }
                },
                '& > .libraryName': {
                    marginLeft: theme.spacing.unit * 4.5,
                }
            }
        }
    },

});

interface RemoveUserRoleDialogProps extends WithStyles<typeof styles> {
    userDetails: UserBody,
    dialogOpen: boolean,
    userRoles: any,
    onClose: () => void,
    usersList: () => void
}


interface RemoveUserRoleDialogState {
    roleId: string
}

class RemoveUserRoleDialog extends Component<RemoveUserRoleDialogProps, RemoveUserRoleDialogState>{
    constructor(props: RemoveUserRoleDialogProps) {
        super(props);
        this.state = {
            roleId: ""
        }

        this.handleChangeEvent = this.handleChangeEvent.bind(this);
    }

    handleChangeEvent(e: any) {
        let { name, value } = e.target;
        let { roleId } = this.state;
        roleId = value;
        this.setState({ roleId });
    }


    handleRemoveRole(e: any) {
        let { roleId } = this.state;
        let { userDetails } = this.props;
        if (userDetails._id && roleId) {
            let ids = roleId.split('-');
            removeUserRole(userDetails._id, ids[0], ids[1])
                .then((resp) => {
                    this.props.onClose();
                    this.props.usersList();
                })
        }
    }

    render() {
        const { userDetails, classes, dialogOpen, onClose, userRoles } = this.props;
        const { roleId } = this.state;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'sm',
            scroll: 'body',
        };

        return (
            <MyPATDialog
                dialogHeading="Remove User Role"
                otherDialogProps={otherDialogProps}
                dialogOpen={dialogOpen}
                onDialogClose={onClose}
            >

                <Card>
                    <CardContent>
                        <Grid container spacing={16}>
                            <Grid item xs={12} >
                                <Typography variant="h6">User Or Group</Typography>
                                <Avatar className={classes.profileAvatar} alt={`Profile ${userDetails.fullName}`} src={_.isEmpty(userDetails.profileImage) ? "/assets/img/profile-default.png" : userDetails.profileImage} />
                                <Typography inline variant="body1" className={classes.userNameEmail}>
                                    {(_.isUndefined(userDetails.userName) || _.isEmpty(userDetails.userName))
                                        ? _.get(userDetails, 'email', '')
                                        : _.get(userDetails, 'userName', '')
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" className={classes.selectRole}>Select Role to remove</Typography>
                                <ul className={classes.rolesList}>
                                    {
                                        _.map(userRoles, (role, i) => (
                                            <li key={`li-role-remove-${i}`} className="controlLabel">
                                                <FormControlLabel
                                                    control={<Radio checked={roleId == `${role._id}-${role.miniLibraryId}`} color="primary" />}
                                                    value={`${role._id}-${role.miniLibraryId}`}
                                                    label={!_.isEmpty(role.name) ? role.name : ""}
                                                    name="roleId"
                                                    key={`role-${i}`}
                                                    onChange={this.handleChangeEvent}
                                                />
                                                <Typography className={classes.miniLiText} key={`miniL-${i}`} variant="caption">{!_.isEmpty(role.miniLibrary) ? role.miniLibrary : ""}</Typography>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Grid>
                            <Grid item xs={12} >
                                <Button variant="contained" color="primary" className={classes.removeRoleBtn}
                                    onClick={this.handleRemoveRole.bind(this)}
                                    disabled={_.isEmpty(roleId) ? true : false}
                                >
                                    Remove Role
						        </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

            </MyPATDialog>
        );
    }
}

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    usersList
}, dispatch);


//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RemoveUserRoleDialog));